import React from 'react';
import RouteHelpers from 'helpers/routes';
import { useAuth } from 'context/auth';
import { Navigate } from 'react-router-dom';
import { hasProductSubscription } from './utils';

interface SubscriptionProps {
  /** The product for which the subscription is required. */
  product:
    | 'platform'
    | 'teachstone_admin'
    | 'data_collection'
    | 'instant_insights';

  /** Optional Dashboard message to display if the subscription is invalid. */
  message?: string;

  /** The children components to render if the subscription is valid. */
  children: React.ReactNode;
}

function Subscription({
  product,
  children,
  message = 'generic-subscription-required'
}: SubscriptionProps) {
  const auth = useAuth();
  const hasSubscription = hasProductSubscription(
    auth.subscription_seats.active,
    product
  );

  return hasSubscription ? (
    <>{children}</>
  ) : (
    <Navigate replace to={RouteHelpers.getPath('app') + `?error=${message}`} />
  );
}

export default Subscription;
